import { Budget, NewBudget, BudgetHead } from "../types/budget-api";
import {api} from './api'
import { withErrorHandling } from './api';

export const getBudgets = async (clientId: string, connectionId: string) => {
  console.log('Fetching budgets for client:', clientId);
  const response = await api.get<BudgetHead[]>(`/clients/${clientId}/connections/${connectionId}/budgets`);
  console.log('Budgets response:', response.data);
  return response.data;
};

export const getBudgetById = async (id: string) => {
  console.log('Fetching budget:', id);
  const response = await withErrorHandling(() => api.get<Budget>(`/budgets/${id}`));
  console.log('Budget response:', response.data);
  return response.data;
};

export const createBudget = async (budget: NewBudget) => {
  console.log('Creating budget:', budget);
  const response = await withErrorHandling(() => api.post<Budget>("/budgets", budget));
  console.log('Create budget response:', response.data);
  return response.data;
};

export const updateBudget = async (id: string, budget: Budget) => {
  console.log('Updating budget:', id);
  const response = await withErrorHandling(() => api.put<Budget>(`/budgets/${id}`, budget));
  console.log('Update budget response:', response.data);
  return response.data;
};

export const deleteBudgetById = async (id: string) => {
  console.log('Deleting budget:', id);
  const response = await withErrorHandling(() => api.delete(`/budgets/${id}`));
  console.log('Delete budget response:', response.data);
  return response.data;
};

export const setBudgetIsActive = async (clientId: string, connectionId: string, budgetId: string) => {
  // log the budget id
  console.log('Set budget active:', budgetId);

  // make the request to the API
  const response = await withErrorHandling(() => api.put<boolean>(`/clients/${clientId}/connections/${connectionId}/budgets/${budgetId}/isactive`, true));
  return response.status === 200;
};

export const triggerPublishBudgets = async (clientId: string, connectionId: string) => {
  console.log(`Publishing budgets for clientId ${clientId} connectionId ${connectionId}`);
  const response = await withErrorHandling(() => api.post<boolean>(`/clients/${clientId}/connections/${connectionId}/budgets/publish`));
  return response.status === 200;
};